export default __webpack_public_path__ + "static/filing-3d73232bd537a83c266433a5a245927c.png";